<form [formGroup]="form">

  <mat-horizontal-stepper #stepper class="h-100 bg-transparent hide-header p-0 fx-1-1-0"
    [linear]="true">


    @for (group of form.groups; track group; let first = $first; let last = $last) {
      <mat-step [label]="group.group.header" [stepControl]="group.formGroup">
        @for (control of group.sortedControls; track control) {
          <div [formGroup]="group">
            @if (control.input; as input) {
              @switch (input.inputType) {
                @case (['multi-select', 'select'].includes(input.inputType) ? input.inputType : '') {
                  <lc-multiselect
                    [displayOptions]="{display: '', multiDisplay: '', displayMultiCount: true}"
                    [displayPath]="'label'" [formControl]="control"
                    [hint]="input.hint"
                    [label]="input.label" [multiple]="input.inputType === 'multi-select'"
                    [options]="input.options"
                    [valuePath]="'value'" />
                }
                @case ('textbox') {
                  <lc-textbox [formControl]="control" [hint]="input.hint"
                    [label]="input.label" [placeholder]="input.placeholder" />
                }
                @case ('checkbox') {
                  <lc-checkbox [formControl]="control" [hint]="input.hint"
                    [label]="input.label" />
                }
                @case ('textarea') {
                  <lc-textarea [formControl]="control" [hint]="input.hint"
                    [label]="input.label" [placeholder]="input.placeholder" [rows]="3" />
                }
                @case ('radio-group') {
                  <lc-radio-group
                    class="hide-form-borders"
                    layout="column"
                    [formControl]="control"
                    [label]="input.label"
                    [options]="input.options"
                    />
                }
                @default {
                  <span>
                    Missing {{option.inputType}}
                  </span>
                }
              }
            }
          </div>
        }
        <mat-divider class="w-100 position-relative mb-3" />
        <div class="form-button-container fx-row fx-gap-xs">
          @if (form.groups.length > 1) {
            <button class="fx-1-1-0" mat-stroked-button matStepperPrevious [disabled]="first">Back</button>
          }
          @if (!last) {
            <button class="fx-1-1-0" color="primary" mat-stroked-button matStepperNext>Next</button>
          }
          @if (last) {
            <button class="fx-1-1-0" color="primary" mat-stroked-button (click)="onDone(group)">Complete</button>
          }
        </div>
      </mat-step>
    }
  </mat-horizontal-stepper>

</form>
